import React from 'react';
import SubmitCommonComponent from './SubmitCommonComponent';
import { SubmitProps } from './utils';

type CompleteVerificationProps = SubmitProps;

const CompleteVerification: React.FC<CompleteVerificationProps> = ({
  isLoading,
  errorMessage,
  onDone,
  handleBack,
  className,
}) => {
  const onClick = () => onDone('Published');
  return (
    <SubmitCommonComponent
      heading="Done with verification?"
      subheading="You’ve accepted all grantee responses, all that’s left is to publish the report!"
      buttonText="Publish"
      onClick={onClick}
      isLoading={isLoading}
      errorMessage={errorMessage}
      className={className}
      handleBack={handleBack}
    />
  );
};

export default CompleteVerification;
